<template lang="pug">
  div()
    #mapTrip(ref="mapTrip" :key="$store.state.global_map_key")
      v-btn.zoomExtends(fab color="primary" @click="zoomExtends")
        v-icon() center_focus_weak
      v-btn#placeButton3(fab color="primary" @click="togglePlaceMarkers")
        v-icon() {{(placeShowMarkers)? 'location_on':'location_off'}}
      v-btn#labelButton(fab color="primary" @click="toggleVehicleMarkers")
        v-icon() {{(showLabel)?'label':'label_off'}}
      #labelButton4.d-flex()
        .viewBtn.viewBtnLeft(:class="$store.state.tracks.mapVectorStyle?['unselectedViewBtn']:['selectedViewBtn']" @click="toggleMapStyle") Satelite View
        .viewBtn.viewBtnRight(:class="$store.state.tracks.mapVectorStyle?['selectedViewBtn']:['unselectedViewBtn']"  @click="toggleMapStyle") Map View
      v-btn#labelButton(fab color="primary" @click="toggleFullscreen")
        v-icon() {{(fullScreen)?'fullscreen_exit':'fullscreen'}}

</template>

<script>
import mapboxgl from "mapbox-gl";
import { lineString, multiLineString } from "@turf/helpers";
import bbox from "@turf/bbox";
import centroid from "@turf/centroid";
import moment from "moment";
const turf = { bbox, centroid, lineString, multiLineString };

// Each marker keeps a breadcrumb trail that is appended to on every AVL message.
// Uncapped it grows for the whole session, and because the trails are rebuilt
// into a MultiLineString on every message the per-message cost grows with it.
const MAX_TRAIL_POINTS = 200;

// coalesce trail redraws; markers themselves still update on every message
const LINE_REDRAW_MS = 250;

export default {
  data: () =>({
    placeShowMarkers:false,
    showLabel: false,
    fullScreen:false,
    geofencePopup:null,
    mapIsLoaded:false,
  }),

  mounted() {
    this.$store.mapTrip = null;
    this.$store.mapTripLoaded = false;

    if(this.$store.state.tracks.currentIndex != -1){
      this.$nextTick(()=>{
        this.createMapTrip();
      })
    }else{
      this.$store.dispatch("tracks/loadAllTracks").then(() => {
        this.$nextTick(()=>{
          this.createMapTrip();
        });
      });
    }

  },

  beforeDestroy() {
    clearTimeout(this.lineRedrawTimer);
    this.lineRedrawTimer = null;
    // Left deferred deliberately. Removing the map synchronously here tears
    // down the instance the freshly-mounted component is still setting up and
    // leaves the live map blank, so the orphaned-map cleanup has to stay a
    // separate piece of work — the handlers below are guarded instead.
    this.$nextTick(() => {
      if (this.$store.mapTrip != null) {
        this.$store.mapTrip.remove();
      }
    });
  },

  computed:{
    avlDataList: function() {
      return this.$store.state.tracks.avl_data;
    },


  },

  watch:{
    avlDataList: function(avlArray) {


      if (avlArray.length > 0) {
        let avlData = avlArray[avlArray.length - 1];
        let tempMarker = this.markerList.find((e) => e.vehicle_id == avlData.vehicle_id)

        // console.log(avlData);
        if (tempMarker != null){
          tempMarker.popUp.setHTML(`${tempMarker.popUpText}<span>Speed: <strong>${avlData.speed}</strong>${this.formatTime(avlData.time)}</span>`);
          tempMarker.setRotation(avlData.angle);
          tempMarker.setLngLat([avlData.location.lon, avlData.location.lat]);
          tempMarker.lineArray.push([avlData.location.lon, avlData.location.lat])
          if (tempMarker.lineArray.length > MAX_TRAIL_POINTS) {
            tempMarker.lineArray.splice(0, tempMarker.lineArray.length - MAX_TRAIL_POINTS);
          }
        }

        // markers move immediately; only the trail redraw is throttled
        this.scheduleLineRedraw();
      }
    }
  },

  methods:{
    formatTime: function(timestamp) {
      if (timestamp) {
        return ` &ndash; ${moment(timestamp).format('HH:mm, Do MMM')}`;
      }else{
        return ""
      }

    },
    // rebuilding the MultiLineString across every marker on each AVL message is
    // the expensive part; coalesce it so a burst of messages costs one redraw
    scheduleLineRedraw: function() {
      if (this.lineRedrawTimer != null) return;
      this.lineRedrawTimer = setTimeout(() => {
        this.lineRedrawTimer = null;
        this.redrawLines();
      }, LINE_REDRAW_MS);
    },

    redrawLines: function() {
      this.multiLineArray = [];
      for(let i=0; i<this.markerList.length; i++){
        this.multiLineArray.push(this.markerList[i].lineArray);
      }

      let multiLine = turf.multiLineString(this.multiLineArray);

      if(this.mapIsLoaded){
        if (this.$store.mapTrip.getSource('theLines') == undefined) {
          if(this.$store.state.tracks.mapVectorStyle){
            this.geoMultiLineSource.paint["line-color"] = "#ed6498";
          }else{
            this.geoMultiLineSource.paint["line-color"] = "#feeef8";
          }
          this.$store.mapTrip.addLayer(this.geoMultiLineSource)
        }
        this.$store.mapTrip.getSource('theLines').setData(multiLine);
      }
    },

    createMapTrip: function() {
      mapboxgl.accessToken =
          "pk.eyJ1IjoibXVnYW1iaWtpbWF0aGkiLCJhIjoiY2p0OWNjaGZxMDdsdjQ0cXZjZTRhZnA0aSJ9.3b3qa7uHHInxWL3TBiMsSQ";
      this.$store.mapTrip = new mapboxgl.Map({
        container: "mapTrip",
        minzoom: 1.3,
        center: [36.76132069660187, -1.2985446867349744], // Nairobi
        zoom: 16,
        keyboard: false
      });
      this.$store.mapTrip.setStyle("mapbox://styles/mapbox/streets-v10");
      const _canvas = this.$store.mapTrip.getCanvas();
      _canvas.setAttribute('tabindex', '-1');
      _canvas.addEventListener('focus', (e) => {
        _canvas.blur();
        if (e.relatedTarget) e.relatedTarget.focus();
      });
     



      this.markerList = [];

      // loop for markerList moving Devices
      for(let i=0; i<this.$store.getters["tracks/getMovingDevices"].length; i++){
        let trackDevice = this.$store.getters["tracks/getMovingDevices"][i];
        let el = document.createElement("div");
        el.className = "myMarker";
        //marker_green_translucent_whitebg.png
        el.setAttribute(
            "style",
            `background-image:url("/static/web/markers/${this.$store.state.tracks.mapVectorStyle?'marker_green_translucent.png':'marker_green_translucent_whitebg.png'}");width:80px;height:80px;background-size:80px 80px;background-position: center center`
        );

        // // create popup
        let tempPopUp = new mapboxgl.Popup({ offset: 25 });
        let operator_name = trackDevice.contact != null ? `<br/>${trackDevice.contact.first_name} ${trackDevice.contact.last_name}`:``;
        let group_name = this.getGroupName(trackDevice.vehicle.id);
        let thumbnail_id = this.getVehicleIcon(trackDevice);

        // tempPopUp.setHTML(`<span style="font-weight: bold"> ${trackDevice.vehicle.name} </span>${operator_name}<br/><span>Speed: ${trackDevice.avl_record.speed}</span>`);
        tempPopUp.setHTML(`<div style="display: block"><div>${thumbnail_id}<span style="font-weight: bold"> ${trackDevice.vehicle.name} </span>${operator_name} ${group_name}<br/><span>Speed: <strong>${trackDevice.avl_record.speed}</strong>${this.formatTime(trackDevice.avl_record.time)}</span></div></div>`);
        tempPopUp.addTo(this.$store.mapTrip);
        // console.log(el)
        // add marker
        let tempMarker = new mapboxgl.Marker(el);
        tempMarker.setLngLat([trackDevice.avl_record.location.lon, trackDevice.avl_record.location.lat]);
        tempMarker.popUp = tempPopUp;
        tempMarker.popUpText = `<div style="display: block"><div>${thumbnail_id}<span style="font-weight: bold"> ${trackDevice.vehicle.name} </span>${operator_name} ${group_name}</div></div>`
        tempMarker.setPopup(tempPopUp);

        tempMarker.addTo(this.$store.mapTrip);
        tempMarker.id = trackDevice.track_device.id;
        tempMarker.vehicle_id = trackDevice.vehicle.id;
        tempMarker.track_device = trackDevice.track_device;
        tempMarker.imei = trackDevice.track_device.imei;
        tempMarker.setRotation(trackDevice.track_device.angle);
        let trg = tempMarker.getElement();
        trg.id = trackDevice.track_device.id;
        trg.vehicle_id = trackDevice.vehicle.id;
        trg.vehicle_name = trackDevice.vehicle.name;
        trg.addEventListener('click', this.onClickMarker);
        // add to cordinates path
        tempMarker.lineArray = [];
        tempMarker.togglePopup();
        // tempMarker.lineArray.push([trackDevice.avl_record.location.lon, trackDevice.avl_record.location.lat])
        this.markerList.push(tempMarker);
      }


      // create place list
      this.placeList = [];


      // Closed over this map, not the global handle, for the same reason as
      // onLoadMap — and guarded, because a removed map returns no canvas.
      let map = this.$store.mapTrip;
      map.on("load", this.onLoadMap);
      map.on('moveend', () => {
        let canvas = map.getCanvas();
        if (canvas != null) canvas.blur();
      });
      map.on('render', () => {
        let canvas = map.getCanvas();
        if (canvas != null && document.activeElement === canvas) {
          canvas.blur();
        }
      });

    },

    showPlaces:function(){
      this.placeList = [];
      if(this.$store.state.place.currentIndex > -1) {
        this._iterateMaps(this.$store.state.place.place_data);
      }else{
        this.$store.dispatch("settings/groupSettings/loadAllGroups").then(()=>{
          this.$store.dispatch("place/loadAllPlaces").then(()=>{
            this._iterateMaps(this.$store.state.place.place_data);
          });
        });
      }
    },

    _iterateMaps(thePlaceArray){
      thePlaceArray.forEach((place) => {
        let group = this.$store.getters["settings/groupSettings/getGroupByID"](place.group_id) || {color:'#007900'};

        // create place marker
        let tempPlaceMarker = new mapboxgl.Marker({ color: group.color });
        tempPlaceMarker.setLngLat([place.location.lon, place.location.lat])
        // create popup
        let tempPopUp = new mapboxgl.Popup();
        tempPopUp.setHTML( `<span style="font-weight: bold"> ${place.name} </span>${(place.description != null)?'<br/><span>'+place.description+'</span>':''}  ${(place.street != null)?'<br/><span  style="color:#999999">'+place.street+'</span>':''}  ${(place.group_id != null)?'<br/><div style="color:#FFFFFF;background-color: #999999; padding: 0px 8px; border-radius: 6px">'+group.name+'</div>':''}`);

        // attach to popup
        tempPlaceMarker.setPopup(tempPopUp);

        // add marker and element to popup
        tempPlaceMarker.addTo(this.$store.mapTrip);
        tempPlaceMarker.id = place.id;
        this.placeList.push(tempPlaceMarker)
      });
    },

    onClickMarker:function(event){

      console.log(event.target.vehicle_id);
      // this.$store.commit("tracks/setCurrentIndexByVehicleID",event.target.vehicle_id);
     //  this.$store.commit("showRightDrawer",{title:event.target.vehicle_name,width:500,component:"RightMapWindow"})
    },

    makeVehiclePopupVisible:function(){
      for(var i=0; i<this.markerList.length; i++){
        if (this.markerList[i].popUp.isOpen() == false){
          this.markerList[i].togglePopup();
        }

      }
    },

    onLoadMap: function(event) {
      // Bind to the map that fired the event rather than re-reading
      // $store.mapTrip. A map orphaned by a remount keeps rendering and still
      // fires load; reading the global there reaches the *successor* map, whose
      // canvas does not exist yet — that is the "undefined.setAttribute" crash.
      const map = (event && event.target) || this.$store.mapTrip;
      if (map == null) return;

        // -- Geofence Areas
      const canvas = map.getCanvas();
      if (canvas == null) return;
      canvas.setAttribute('tabindex', '-1');
      canvas.addEventListener('focus', () => canvas.blur());

        map.addSource('geofence_origi', {
            'type': 'geojson',
            'data': '/api/geofence/geoJSONCollection'
        });

        map.addLayer({
            'id': 'geofence_fill',
            'type': 'fill',
            'source': 'geofence_origi', // reference the data source
            'layout': {},
            'paint': {
                'fill-color': '#0d97f7', // blue color fill
                'fill-opacity': 0.3,

            }
        });

        map.addLayer({
            'id': 'geofence_line',
            'type': 'line',
            'source': 'geofence_origi', // reference the data source
            'layout': {},
            'paint': {
                "line-color": "#000f4e",
                "line-width": 2,

            }
        });

        map.on('mouseenter', 'geofence_fill', (e) => {

            // while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
            //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            // }

            console.log(`mouse enter ${e.features[0].properties.name} at loc ${e.features[0].properties}`)
            let centroidCoord = [36.76132069660187, -1.2985446867349744]

            let theGeometry = JSON.parse(e.features[0].properties.geometry)
            if(theGeometry.type == "Point"){
                centroidCoord = theGeometry.coordinates;
            }else{
                let centroid = turf.centroid(e.features[0]);
                centroidCoord = centroid.geometry.coordinates;
            }


            this.geofencePopup = new mapboxgl.Popup({closeButton: false})
                .setLngLat(centroidCoord)
                .setHTML(`<i>Geofence:</i><br/><b>${e.features[0].properties.name}</b><br/>${e.features[0].properties.description??""}`)
            this.geofencePopup.addTo(map)
        });

        map.on('mouseleave', 'geofence_fill', () => {
            this.geofencePopup.remove()
        });


        //-- End Geofence Areas


      let multiLine = turf.multiLineString([[[0,0],[10,10]], [[-24, 63], [-23, 60], [-25, 65], [-20, 69]]]);
      console.log(multiLine)

      this.geoMultiLineSource = {
        id: "theLines",
        source: {
          type: "geojson",
          data: multiLine
        },
        type:"line",
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#ed6498",
          "line-width": 4,
          "line-opacity": 1
        }
      }
      map.addLayer(this.geoMultiLineSource)
      map.resize();
      this.zoomExtends();



      this.mapIsLoaded = true;
    },


    drawLines(){
      this.multiLineArray = [];
      for(let i=0; i<this.markerList.length; i++){
        this.multiLineArray.push(this.markerList[i].lineArray);
      }

      let multiLine = turf.multiLineString(this.multiLineArray);

      this.$store.mapTrip.getSource('theLines').setData(multiLine);



    },

    zoomExtends() {
      var bbox;

      if (typeof this.multiLineArray == "undefined") {
        let tempArrayCoordinates = [];
        this.markerList.forEach(e => {
          tempArrayCoordinates.push([e.getLngLat().lng, e.getLngLat().lat])
        })
        if (tempArrayCoordinates.length == 0) {
          return;
        }
        if (tempArrayCoordinates.length > 1) {
          let line = turf.lineString(tempArrayCoordinates, {name: "lineFromMarkers"});
          bbox = turf.bbox(line);
          this.$store.mapTrip.fitBounds(bbox, {
            padding: 40
          })
        } else {
          this.$store.mapTrip.flyTo({
            center: tempArrayCoordinates[0],
            essential: true,
          })
        }

      } else {
        let multiLine = turf.multiLineString(this.multiLineArray);
        bbox = turf.bbox(multiLine);
        this.$store.mapTrip.fitBounds(bbox, {
          padding: 40
        })
      }

      this.makeVehiclePopupVisible();
    },

    toggleVehicleMarkers: function() {
      this.showLabel = !this.showLabel
      this.markerList.forEach((vehicleMarker) => {
        vehicleMarker.togglePopup();
      })
    },

    togglePlaceMarkers: function() {
      this.placeShowMarkers = !this.placeShowMarkers;
      if(this.placeShowMarkers == true){
        this.showPlaces();
      }else{
        this.placeList.forEach((placeMarker) => {
          placeMarker.remove();
        });
      }

      this.toggleVehicleMarkers();
    },

    toggleFullscreen: function(){
      console.log("FULL SCREEN")
      // document.fullscreenEnabled
      // if this.$refs.mapDashboard
      let mapTrip = this.$refs.mapTrip
      if(this.fullScreen){
        document.exitFullscreen();
        this.fullScreen = false;
      }else{
        mapTrip.requestFullscreen()
        this.fullScreen = true;
      }



    },

    getGroupName: function(vehicle_id){
      let tempVehicle = this.$store.getters["vehicles/getVehicleByID"](vehicle_id);
      if (tempVehicle != null && tempVehicle.group != null && tempVehicle.group.name != null){
        return " | "+tempVehicle.group.name;
      }
      return "";
    },

    getVehicleIcon: function (trackDevice) {
      let vehicle_id = trackDevice.vehicle.id
      let tempVehicle = this.$store.getters["vehicles/getVehicleByID"](vehicle_id);
      if (tempVehicle != null && tempVehicle.thumbnail_id != null && tempVehicle.thumbnail.thumbnail != null) {
        return `<div ><img src="/media/${tempVehicle.account_id}/${tempVehicle.thumbnail.thumbnail}" style="width:80px;height: 60px; object-fit: cover; ${trackDevice.avl_record.ignition?'border: 4px solid #1d970c;border-radius: 10px':'border-radius: 5px'}"> </div>`
      }
      return "";
    },

    toggleMapStyle: function(){
      if(this.$store.state.tracks.mapVectorStyle){
        this.$store.mapTrip.setStyle("mapbox://styles/mapbox/satellite-streets-v12");
      }else{
        this.$store.mapTrip.setStyle("mapbox://styles/mapbox/streets-v10");
      }
     this.$store.commit("tracks/toggleMapVectorStyle");
      let mapContainer = this.$store.mapTrip.getContainer();
      let elements = mapContainer.getElementsByClassName('myMarker')
      for (var i=0; i<elements.length; i++){
        // console.log(elements[i].style)
        elements[i].style = `background-image:url("/static/web/markers/${this.$store.state.tracks.mapVectorStyle?'marker_green_translucent.png':'marker_green_translucent_whitebg.png'}");width:80px;height:80px;background-size:80px 80px;background-position: center center;`
      }




    },



  },


}
</script>

<style scoped lang="stylus">
#mapTrip {
  height: 100%
  width 100%;
}

  .zoomExtends{
    position absolute;
    top 10px;
    right 30px;

  }

#placeButton3 {
  position: absolute;
  top:90px;
  right:30px;

}

#labelButton{
  position: absolute;
  top: 170px;
  right: 30px;

}

#labelButton4 {
  position: absolute;
  top:20px;
  right:120px;
}
  .viewBtn{
    //background-color:#FF0000;
    border: 2px solid #ec037b;
    padding: 6px 20px;
    font-size: 16px;
    text-align: center;
    vertical-align: center;


  }

    .viewBtnRight{
      border-bottom-right-radius: 10px
      border-top-right-radius: 10px;
    }

.viewBtnLeft{
  border-bottom-left-radius: 10px
  border-top-left-radius: 10px;
}
.unselectedViewBtn{
  background-color: rgba(255, 255, 255, 0.67);
  color: #ec037b;
  cursor: pointer;
}
  .selectedViewBtn{
    background-color: #ec037b;
    color: #FFFFFF;
    font-weight: bold;
  }

  .thumbnailOn{
    border:4px solid #1d970c;
    border-radius: 10px;
  }

  .thumbnailOff{
    border:4px solid #000000;
  }

</style>
